module.exports = __webpack_public_path__ + "img/pwa-ios-1.56cd963b.png";